export const mapConfig = {
    initialMapCoordinates: [51.917, 19.013],
    initialMapZoom: 7,
    maxMapZoom: 19,
};
